import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Subject} from "rxjs";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {UserCashbackHistoryService} from "../services/user-cashback-history.service";
import {ICashBackHistory, ICashbackHistoryItem} from "../services/interfaces/cashback-history.interface";
import {MatDialog} from "@angular/material/dialog";
import {ReasonComponent} from "../../../../@shared/modals/reason/reason.component";
import {LogType} from "../../../../@core/enums/log-type.enum";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-cashback-history',
  templateUrl: './cashback-history.component.html',
  styleUrls: ['./cashback-history.component.scss']
})
export class CashbackHistoryComponent implements AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild('cashbackTable', {read: MatSort, static: true}) cashbackTable: MatSort;

  public isGoFast: boolean = environment.projectName === 'CSGOFAST';

  public userCashbackHistoryColumns = ['count', 'gameTypeId', 'gameId', 'amount', 'date', 'isTaken'];
  public userCashbackHistoryData: MatTableDataSource<ICashbackHistoryItem> = new MatTableDataSource();

  public selectedDate: { start: string, end: string };
  public isLoading = true;
  public logType = LogType;
  private readonly destroyed$: Subject<void> = new Subject<void>();

  public totalRows = 0;
  public pageSize = 10;
  public currentPage = 0;
  public pageSizeOptions: number[] = [10, 25, 50, 100];

  constructor(private userCashbackHistoryService: UserCashbackHistoryService,
              private dialog: MatDialog) {
    this.subscribeEmitters();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngAfterViewInit() {
    this.userCashbackHistoryData.sort = this.cashbackTable;
  }

  public changeDateFilter(filter: { start: string, end: string }): void {
    this.isLoading = true;
    this.selectedDate = filter;
    this.userCashbackHistoryService.requestUserCashbackHistory(filter, this.pageSize, this.currentPage)
  }

  public pageChanged(event: PageEvent) {
    this.isLoading = true;
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.userCashbackHistoryService.requestUserCashbackHistory(this.selectedDate, this.pageSize, this.currentPage)
  }

  public resetCashback(): void {
    this.dialog.open(ReasonComponent)
      .afterClosed()
      .pipe(
        filter(reason => !!reason),
        switchMap((reason: string) => this.userCashbackHistoryService.resetCashback(reason))
      )
      .subscribe(
        () => this.userCashbackHistoryService.requestUserCashbackHistory(this.selectedDate, this.pageSize, this.currentPage)
      )

  }

  private subscribeEmitters(): void {
    this.userCashbackHistoryService.userCashbackHistory$
      .pipe(
        takeUntil(this.destroyed$),
        filter((cashbackHistory: ICashBackHistory) => !!cashbackHistory)
      )
      .subscribe((cashbackHistory: ICashBackHistory) => {
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = cashbackHistory.meta.count;
        });
        this.userCashbackHistoryData.data = cashbackHistory.items;
        this.isLoading = false;
      })
  }
}
